import { Link } from 'react-router-dom'
import { ShieldAlert, ArrowLeft } from 'lucide-react'
import { useAuthStore } from '../stores/authStore'

const roleLabel: Record<string, string> = {
  ADMIN: 'Administrador',
  MANAGER: 'Gerente',
  DENTIST: 'Odontologo',
  HYGIENIST: 'Higienista',
  RECEPTIONIST: 'Recepcionista',
}

export function ForbiddenPage({ permissions = [] }: { permissions?: string[] }) {
  const user = useAuthStore((s) => s.user)
  const role = user?.role ? roleLabel[user.role] ?? user.role : 'desconocido'

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-6">
      <div className="bg-surface-1 border border-border rounded-xl p-8 max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-warning-50 mb-4">
          <ShieldAlert className="w-7 h-7 text-warning-500" />
        </div>
        <h1 className="text-xl font-bold text-text-primary mb-2">Acceso restringido</h1>
        <p className="text-sm text-text-secondary mb-1">
          Tu perfil ({role}) no tiene permisos para entrar a esta seccion.
        </p>
        {permissions.length > 0 && (
          <p className="text-xs text-text-tertiary mb-5">
            Permisos requeridos:{' '}
            {permissions.map((p, i) => (
              <span key={p}>
                <span className="font-mono bg-surface-2 px-1.5 py-0.5 rounded">{p}</span>
                {i < permissions.length - 1 ? ' o ' : ''}
              </span>
            ))}
          </p>
        )}
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-4 py-2.5 bg-primary-600 hover:bg-primary-700 text-white text-sm font-semibold rounded-lg transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>
      </div>
    </div>
  )
}
